const business = {
    category_heading: "",
    category_text : "",
    colleagues_heading : "",
    currency : "HUF",
    name: "",
    country: "HU",
    state : "",
    city : "",
    zip : "",
    address : "",
    vat_number : "",
    incorporation_type : "company",
    colleagues_text : "",
    color : "",
    contact_heading : "",
    contact_text : "",
    facebook : "",
    hero_heading : "",
    hero_text: "",
    id: "",
    instagram: "",
    maps: "",
    mandatory_billing_details: 'optional',
    automatic_invoice: false,
    webshop_cash_payment: true,
    webshop_card_payment: false,
    usage_type: 'website',
    payment_type: "simple",
    payment_on: false,
    public_address: "",
    public_email: "",
    public_logo: "",
    public_name: "",
    public_phone: "",
    redirect_url: "",
    subdomain: "",
    subscription: "none",
    twitter: "",
    youtube: "",
    payment_credentials: {merchant_id: "", secret_key: ""},
    payment_authorized: false,
    invoice_service: ''
}

export default business